import { Typography } from '@mui/material';
import { Dialog } from 'components/Dialog';
import { useContractUpdateDialog } from './useContractUpdateDialog';

export default function ContractUpdateDialog() {
  const { isOpenDialog, handleClickDialog, handleCloseDialog } =
    useContractUpdateDialog();

  return (
    <Dialog
      open={isOpenDialog}
      title="授課教師承攬契約書更新"
      confirm={{ text: '立即簽約', action: handleClickDialog }}
      disConfirm={{
        text: '稍後完成',
        action: handleCloseDialog,
        show: true,
      }}
      close={{ text: 'x', action: () => {} }}
    >
      <Typography variant="body1">
        契約內容已更新，為保障您的權益，請您點擊「立即簽約」或於左側會員中心選單中點擊「契約更新」完成簽約，以免影響排課權利。
      </Typography>
    </Dialog>
  );
}
